<template>
    <div class="hxstepsDetail">
        <div id="amapContainer" style="width:100vw;height:100vh;"></div>
        <!-- <div class="notice">
          <van-notice-bar
              color="#ffffff" background="rgba(0,0,0,.3)"
              left-icon="volume-o"
              text="地图非真实比例地图，详细地址见点位信息。"
          />
        </div> -->

        <div class="header">
            <van-image :src="userInfo.userInfo.avatarurl"></van-image>
            <span>
            <ICountUp :endVal="userTaskInfo.totalSteps*1"/>
         </span>
         <span>自  {{userTaskInfo.join_start_time}}起累计</span>
        </div>
        <!-- <div class="rules" @click="rulesShow=true">
            <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20221209/1670567106/245146.png" alt/>
        </div> -->
        <div class="rank" @click="gorank">
            <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20221209/1670567106/509808.png" alt/>
        </div>
        <div class="footer">
            <div>
                <span>{{userTaskInfo.currentFinished}}</span>
                已点亮点位
            </div>
            <div @click="handleSteps" v-if="userTaskInfo.currentFinished<point.length">
                <a>点亮</a>
            </div>
            <div @click="getcard" v-else>
              <a style="font-size:.4rem;">
                下载
                <br/>证书
              </a>
            </div>

            <div>
                <div>
                    <span>{{freenum}}</span>
                    抽奖机会
                </div>
                <img src="@/assets/img/steps/draw.png" alt @click="goluckdraw"/>
            </div>
        </div>
        <van-dialog
                v-model="rulesShow"
                title="活动规则"
                :style="{width:'80vw' }"
                round
                close-on-click-overlay
        >
            <div style="padding:0rem;overflow: scroll;height:40vh;" v-html="detail.intro"></div>
        </van-dialog>
        <Popup
                v-model="pointShow"
                get-container="#app"
                :style="{ width: '80%',overflowY:'inherit' }"
                round
                close-on-click-overlay
                @closed="closepointShow"
        >
            <div class="xhpointDesc">
                <!-- <div id="fireworks" v-if="activityPoints.playerInfo!=null && activityPoints.id==137">
                    <img src="@/assets/img/steps/fire/1.png" alt="">
                    <img src="@/assets/img/steps/fire/2.png" alt="">
                    <img src="@/assets/img/steps/fire/3.png" alt="">
                    <img src="@/assets/img/steps/fire/4.png" alt="">
                    <img src="@/assets/img/steps/fire/5.png" alt="">
                </div> -->
                <div>
                    <header>
                        <div class="headertitle">{{activityPoints.title}}</div>
                    </header>
                    <div class="shortdesc">{{activityPoints.shortdesc}}</div>
                    <div class="intro" v-if="activityPoints.description">
                        <div class="introtitle">
                            
                        </div>
                        <div >
                            <div v-html="activityPoints.description"></div>
                        </div>
                    </div>

                    <footer style="margin-top:10px;color:#393940;font-size: .3rem;"
                            v-if="activityPoints.msg && activityPoints.futurecan*1">
                        您还可以继续点亮 <span style="color: #FF5D4B">{{activityPoints.futurecan}}</span>个<br>是否继续点亮?
                    </footer>

                    <div class="button" @click="handleSteps" v-if="activityPoints.futurecan*1">继续点亮</div>

                    <div  style="color:#999;font-size: .3rem;margin-top:10px;"  @click="pointShow=false" v-if="activityPoints.futurecan*1">
                        取消
                    </div>
                    <div class="button" @click="pointShow=false" v-else>
                       确定
                    </div>

                </div>
            </div>
        </Popup>
    </div>
</template>
<script>
    var points = [[[264,544], [264,544]],[[264,544], [326,620]],
      [[326,620], [426,744]],
      [[426,744],[532,876]],
      [[532,876], [594,950],[594,1022]],
      [[594,1022], [594,1150]],
      [[594,1150], [594,1202], [512,1248]],
      [[512,1248], [376,1326]],
      [[376,1326], [274,1268]],
      [[274,1268], [158,1202]],
      [[158,1202], [158,1056]],
      [[158,1056], [158,950], [232,908]],
      [[232,908], [374,826]],
      [[374,826], [594,700]],
      [[594,700], [594,560]],
      [[594,560], [594,466], [508,396]],
      [[508,396], [378,322]],
      [[378,322], [238,400]],
      [[238,400], [158,466], [158,546]],
      [[158,546], [158,700]],
      [[158,700], [262,830]],
      [[262,830], [406,1008]],
      [[406,1008], [472,1090]],
      [[472,1090],[472,1090]]
    ];
    for(var i = 0;i<points.length;i++){
      for(var j = 0;j<points[i].length;j++){
        points[i][j][0] = (points[i][j][0] - 335)*0.000004487*10 + 121.475708
        points[i][j][1] = ((1451-points[i][j][1]) - 525)*0.000003457*10 + 31.201219
      }
    }
    var offset = [
        [-15, 20], //1
        [-15, 12], //2
        [-15, 12],//3
        [-15, 12],//4
        [-15, 12],//5
        [-15, 12],//6
        [-15, 12],//7
        [-15, 12],//8
        [-15, 12],//9
        [-15, 12],//10
        [-15, 12],//11
        [-15, 12],//12
        [-15, 12], //13
        [-15, 12],  //14
        [-15, 12], //15
        [-15, 12],
        [-15, 12],
        [-15, 12],
        [-15, 12],
        [-15, 12],
        [-15, 12],
        [-15, 12],
        [-15, 20],
    ];
    var offset14 = [
        [-15, 20], //1
        [-15, 12], //2
        [-15, 12],//3
        [-15, 12],//4
        [-15, 12],//5
        [-15, 12],//6
        [-15, 12],//7
        [-15, 12],//8
        [-15, 12],//9
        [-15, 12],//10
        [-15, 12],//11
        [-15, 12],//12
        [-15, 12], //13
        [-15, 12],  //14
        [-15, 12], //15
        [-15, 12],
        [-15, 12],
        [-15, 12],
        [-15, 12],
        [-15, 12],
        [-15, 12],
        [-15, 12],
        [-15, 20],
    ];


    var arr = [];
    import {mapGetters} from "vuex";
    import PinchZoom from "vue-pinch-zoom";
    import {Button, Image, Loading, Swipe, SwipeItem, Popup, Collapse, CollapseItem, NoticeBar, RadioGroup, Radio,Dialog} from "vant";
    import Footbar from "@/components/footbar/index";
    import ICountUp from "vue-countup-v2";
    import {lazyAMapApiLoaderInstance} from "vue-amap";
    import moment from 'moment';
    // import VConsole from 'vconsole'

    export default {
        name: "checkDetail",
        props: ["activity_id","acid"],
        computed: {
            ...mapGetters({
                userInfo: "getUserInfo"
            })
        },
        data() {
            return {
                showMore:false,
                activityPoints:{},
                collapsename: [],
                hasques: false,
                point: [],
                pointShow: false,
                pointShowFrom: 1,
                rulesShow: false,
                userTaskInfo: {
                    currentFinished: 0,
                    totalSteps: 0
                },
                sigining: false,
                freenum: 0,
                detail: {},
                markers:[],
                markers14:[],
                systime: '',
                answershow: false,
                lettersarr: [
                  "A",
                  "B",
                  "C",
                  "D",
                  "E",
                  "F",
                  "G",
                  "H",
                  "I",
                  "J",
                  "K",
                  "L",
                ],
                question: {},
                answer: [],
                bind_subid: '',
                drawshow: false,
                answererror: false,
                check: '',
                finished: 0
            };
        },
        components: {
            Button,
            VanImage: Image,
            Footbar,
            Loading,
            Swipe,
            SwipeItem,
            ICountUp,
            Popup,
            PinchZoom,
            Collapse,
            CollapseItem,
            VanNoticeBar:NoticeBar,
          VanRadioGroup:RadioGroup,
          VanRadio:Radio
        },
        methods: {
          gorank() {
            wx.miniProgram.navigateTo({
                url:'/v2/activity/step/rank?activity_id='+this.activity_id
            });
          },
            getcard() {
              this.$api.activity
                  .getCert({id: this.activity_id})
                  .then(res => {
                    wx.previewImage({
                      urls: [res.data.cert]
                    });
                  });
              return;
            },
            handleSteps() {
                let that = this
                var timestamp = this.systime;
                var starttime = this.detail.start_time*1
                // var endtime = this.detail.end_time*1
                if(timestamp<starttime){
                  this.$toast('还未开始，请耐心等待');
                  return;
                }
                // let list = this.point
                // let  res = list.find(item => item.hasanswer == 0&&item.playerInfo != null)
                // if(res){
                //   this.getques()
                //   this.answershow = true
                //   this.bind_subid = res.id
                //   this.answer = []
                //   return
                // }
                this.$toast.loading("处理中...");
                this.$api.steps.stepsCheckin(Object.assign({api_throw_exception: false}, this.$route.params)).then(
                   res => {

                      this.sigining = false;
                      this.$toast.clear();
                      if (+res.status !== 200) {
                          this.$toast({
                              type: 'html',
                              position: "bottom",
                              message: "<div style='display: flex;align-items: center;font-size:12px;'>" +
                                  "<img src='" + require("@/assets/img/steps/run.png") + "' style='width:.44rem;height:.44rem;margin-right: 5px;'>" + res.message + "</div>",
                              duration: 5000,
                              className: "bottomToast"
                          })

                          return;
                      }

                      let {finided, betweenSteps} = res.data;
                      this.activityPoints = Object.assign(finided,{playerInfo:{}});
                      if (!this.pointShow) this.pointShow = true;
                      this.userTaskInfo.totalSteps = betweenSteps;
                      this.activityDetail();
                      this.getTaskList();
                    },
                    () => {

                    }
                );
            },

            getTaskList() {
                let that = this;
                new Promise(function (resolve, reject) {
                    //先清除所有的marker
                    that.map.remove(that.markers14)
                    that.map.remove(that.markers);
                    that.$api.activity.taskList(that.$route.params).then(res => {
                        if (res.status * 1 === 200) {
                            var {subList, intro, title, relation_actvity_id, relation_activity_type} = res.data;
                            var currentFinished = 0;
                            subList.unshift({
                                imgurl: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20221212/1670815832/640250.png',
                                icon: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20221212/1670815832/640250.png'
                            })
                            subList.push({
                                imgurl: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20221212/1670815832/46187.png',
                                icon: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20221212/1670815832/46187.png'
                            })


                            var finshedLine = [];
                            var finshedfirstpoint = [];
                            var markers = [];
                            var markers14 = [];

                            if(relation_actvity_id != ''&&relation_activity_type==5){
                              that.hasques = true
                            }

                            subList.forEach((item, index) => {
                                if (!!item.playerInfo) {
                                    currentFinished++;
                                    var icon = new AMap.Icon({
                                        size: new AMap.Size(70, 70),    // 图标尺寸
                                        image: item.imgurl,
                                        imageSize: new AMap.Size(70, 70),   // 根据所设置的大小拉伸或压缩图片
                                    });
                                    var marker = new AMap.Marker({
                                        position: points[index][points[index].length - 1],
                                        icon: icon, // 添加 Icon 实例
                                        offset: new AMap.Pixel(offset[index][0], offset[index][1]), //设置偏移量
                                        anchor: 'bottom-left', // 设置锚点方位
                                        title: index,
                                        zIndex:1000
                                    });

                                    marker.on('click', function (e) {
                                        that.markerClick(e)
                                    })


                                    var icon14 = new AMap.Icon({
                                        size: new AMap.Size(35,35),    // 图标尺寸
                                        image: item.imgurl,
                                        imageSize: new AMap.Size(35,35),   // 根据所设置的大小拉伸或压缩图片
                                    });
                                    var marker14 = new AMap.Marker({
                                        position: points[index][points[index].length - 1],
                                        icon: icon14, // 添加 Icon 实例
                                        offset: new AMap.Pixel(offset14[index][0], offset14[index][1]), //设置偏移量
                                        anchor: 'bottom-left', // 设置锚点方位
                                        title: index,
                                        zIndex:1000
                                    });

                                    marker14.on('click', function (e) {
                                        that.markerClick(e)
                                    })


                                    var content = '<div class="first-pointx activity">' + (index+1) + "</div>";
                                    finshedfirstpoint.push(
                                        new AMap.Marker({
                                            position: points[index][points[index].length - 1],
                                            content,
                                            offset: new AMap.Pixel(-12.5,5), //设置偏移量
                                            anchor: 'bottom-left', // 设置锚点方位
                                            zooms: [14,16],
                                            zoom: 15,
                                        })
                                    );
                                    finshedLine = finshedLine.concat(points[index])
                                  if(currentFinished==21){
                                    finshedLine = finshedLine.concat(points[index+1],points[index+2])
                                  }
                                } else {
                                    var icon = new AMap.Icon({
                                        size: new AMap.Size(70, 70),    // 图标尺寸
                                        image: item.icon,
                                        imageSize: new AMap.Size(70, 70),   // 根据所设置的大小拉伸或压缩图片
                                    });

                                    var marker = new AMap.Marker({
                                        position: points[index][points[index].length - 1],
                                        icon: icon, // 添加 Icon 实例
                                        offset: new AMap.Pixel(offset[index][0], offset[index][1]), //设置偏移量
                                        anchor: 'center', // 设置锚点方位
                                        title: index,
                                        zooms: [14,16],
                                        zoom: 15,
                                        zIndex:999

                                    });

                                    AMap.event.addListener(marker,'click',that.markerClick);

                                    marker.on('click', function (e) {
                                        that.markerClick(e)
                                    })



                                    var icon14 = new AMap.Icon({
                                        size: new AMap.Size(35, 35),    // 图标尺寸
                                        image: item.icon,
                                        imageSize: new AMap.Size(35, 35 ),   // 根据所设置的大小拉伸或压缩图片
                                    });
                                    var marker14 = new AMap.Marker({
                                        position: points[index][points[index].length - 1],
                                        icon: icon14, // 添加 Icon 实例
                                        offset: new AMap.Pixel(offset14[index][0], offset14[index][1]), //设置偏移量
                                        anchor: 'bottom-left', // 设置锚点方位
                                        title: index,
                                        zIndex:1000
                                    });

                                    marker14.on('click', function (e) {
                                        that.markerClick(e)
                                    })
                                }
                                markers.push(marker);
                                markers14.push(marker14);
                            });
                            // 已经完成的创建折线实例
                            if(finshedLine.length>0){
                                var polyline = new AMap.BezierCurve({
                                    path: finshedLine,
                                    lineJoin: "round",
                                    lineCap: "round",
                                    strokeWeight: 1,
                                    strokeColor: "#FFFFFF",
                                    outlineColor: "#447BE0",
                                    borderWeight: 4,
                                    isOutline: true,
                                    strokeStyle: "dashed"
                                });
                                polyline.setMap(that.map)
                            }

                            that.markers = markers;
                            that.markers14 = markers14;

                            var zoom = that.map.getZoom()
                            if(zoom==14){
                                that.map.add(markers14)
                            }else{
                                that.map.add(markers);
                            }
                            that.map.add(finshedfirstpoint);
                            that.point = res.data.subList;
                            that.detail = res.data;
                            that.systime = res.timestamp
                            that.userTaskInfo.currentFinished = currentFinished;
                            that.userTaskInfo.join_start_time = moment(res.data.start_time*1000).format('MM月DD日');
                            let index = currentFinished - 1 <= 0 ? 0 : currentFinished - 1
                            index = index + 1 >= 20 ? 20 : (index + 1)
                            that.map.setCenter(
                                points[index][0]
                            );
                            resolve(Object.assign(res.data, {currentFinished}));
                        }
                    });
                }).then(e => {
                    let {start_time, end_time} = e;
                    that.$api.steps.stepsInfo({start_time, end_time}).then(res => {
                        if (+res.status === 200) {
                            let totalSteps = +res.data;
                            this.userTaskInfo = Object.assign(this.userTaskInfo, {
                                totalSteps
                            });
                        }
                    });
                });
            },
            activityDetail: function () {
                this.$api.activity.activityDetail({acid: this.acid}).then(res => {
                    this.freenum = res.data.freenum;
                });
            },
            goluckdraw: function () {
                this.$router.push({name: "luckdraw", params: {acid: this.acid}});
            },
            markerClick: function (e) {
              console.log(e.target.getTitle(),111)
                if(+e.target.getTitle()===0 && +e.target.getTitle()===22) return
                // if(+e.target.getTitle()===22 && this.userTaskInfo.currentFinished<22){

                //     this.$dialog.alert({
                //         title: '提示',
                //         width:'80vw',
                //         message: '您还未走完本次活动的其他点位。\r\n完成所有任务后可查看该点位详情！',
                //     }).then(() => {
                //         // on close
                //     });
                //     return ;
                // }


                this.activityPoints = this.point[e.target.getTitle()];
                this.pointShow = true;
                this.pointShowFrom = 2;
            },
            closepointShow: function () {
                this.pointShowFrom = 1;
                this.collapsename = []
                this.activityPoints= {}
              this.pointShow = false;
            }
        },
        mounted() {
            this.$api.user.getUserInfo().then((res) => {
            if (res.status * 1 === 200) {
                let userInfo = res.data;
                if(userInfo.nickname == '微信用户' ||userInfo.phone == '' ||userInfo.phone == null){
                    Dialog.alert({
                        title: '温馨提醒',
                        message: '为便于后续奖励登记发放，请到个人中心完善昵称、姓名、手机号等个人信息',
                    })
                    .then(() => {
                        // on confirm
                        wx.miniProgram.reLaunch({
                            url:'/pages/user/bindphone/index'
                        });
                    });
                }
            }
            });
            
        //   new VConsole()
            // this.$nextTick(() => {
            lazyAMapApiLoaderInstance.load().then(() => {
                var imageLayer = new AMap.ImageLayer({
                    url: "https://oss.mcloud.moveclub.cn/alphamovecloud/20221212/1670815832/929353.jpeg",
                    bounds : new AMap.Bounds(
                        [121.448977,31.172059], [121.513453,31.230226]
                    ),
                    zooms: [14,16],
                    zoom: 15,
                    opacity:1
                });
                let layer_std = new AMap.TileLayer();
                this.map = new AMap.Map("amapContainer", {
                    resizeEnable: true,
                    center: [121.491708,31.196219],
                    zooms: [14,16],
                    zoom: 14,
                    layers: [layer_std, imageLayer],
                    mapStyle: "amap://styles/whitesmoke",
                });

                this.map.remove(layer_std);
                var linePoint = [];
                var firstPointMarkers = [];
                points.forEach((item, index) => {
                    linePoint = linePoint.concat(item);
                    var content = '<div class="first-pointx">' + index + "</div>";
                    if (index) {
                        firstPointMarkers.push(
                            new AMap.Marker({
                                position: item[0],
                                content,
                                animation:"AMAP_ANIMATION_DROP",
                                offset: new AMap.Pixel(-12.5,5), //设置偏移量
                                anchor: 'bottom-left', // 设置锚点方位
                            })
                        );
                    }

                });
             //限制范围
                var bounds = new AMap.Bounds(
                    [121.461521,31.165198], [121.524464,31.22753]
                )
                this.map.setLimitBounds(bounds);
                this.map.add(firstPointMarkers);
                var that = this;
                setTimeout(() => {
                    var polyline = new AMap.BezierCurve({
                        path: linePoint,
                        lineJoin: "round",
                        lineCap: "round",
                        strokeWeight: 1,
                        strokeColor: "#FFFFFF",
                        outlineColor: "#999999",
                        borderWeight: 4,
                        isOutline: true,
                        strokeStyle: "dashed"
                    });
                    polyline.setMap(that.map)
                    that.getTaskList();
                    that.activityDetail();
                }, 1)

                this.map.setFeatures("building")

                this.map.on("click",function (e) {
                    console.log(e);
                })

                this.map.on('zoomend',function (e) {
                    var zoom = that.map.getZoom()
                    if(zoom==14){
                        that.map.remove(that.markers);
                        that.map.add(that.markers14)
                    }else{
                        that.map.remove(that.markers14)
                        that.map.add(that.markers);
                    }

                })



            });

            // })

        }
    };
</script>
<style lang="less">
    @import "Detail.less";
</style>
